import React from "react";

const ChallengesIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_12655_3802)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8741 14.4612C13.7961 14.6241 13.7524 14.807 13.7524 15V16.6545C13.7524 16.9841 13.8828 17.3008 14.1153 17.535L15.782 19.2137C16.1386 19.5733 16.677 19.682 17.1453 19.4891C17.6136 19.2962 17.9191 18.8395 17.9191 18.3333V17.9166H18.3357C18.8411 17.9166 19.297 17.612 19.4907 17.145C19.6841 16.6779 19.577 16.1404 19.2195 15.7829L17.5528 14.1162C17.3186 13.8816 17.0007 13.75 16.6691 13.75H15.0024C14.8095 13.75 14.6266 13.7937 14.4636 13.8716L10.297 9.70537C10.1345 9.54287 9.87031 9.54287 9.70781 9.70537C9.54531 9.86787 9.54531 10.132 9.70781 10.2945L13.8741 14.4612ZM17.0857 18.3333C17.0857 18.502 16.9841 18.6541 16.8278 18.7187C16.6716 18.7829 16.4924 18.7466 16.3732 18.6266L14.7066 16.9479C14.6291 16.8699 14.5857 16.7641 14.5857 16.6545V15C14.5857 14.77 14.7724 14.5833 15.0024 14.5833H16.6691C16.7795 14.5833 16.8857 14.627 16.9636 14.7054L18.6303 16.372C18.7495 16.4912 18.7853 16.6704 18.7207 16.8262C18.6562 16.9816 18.5041 17.0833 18.3357 17.0833H17.5024C17.3916 17.0833 17.2857 17.1275 17.2074 17.2058C17.1295 17.2841 17.0853 17.39 17.0857 17.5008V18.3333Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="0.35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1942 18.1482C12.205 18.5365 11.128 18.7498 10.0013 18.7498C5.17214 18.7498 1.2513 14.829 1.2513 9.99984C1.2513 5.17067 5.17214 1.24984 10.0013 1.24984C14.8305 1.24984 18.7513 5.17067 18.7513 9.99984C18.7513 11.1236 18.5392 12.1982 18.1525 13.1848C18.0688 13.399 18.1746 13.6411 18.3888 13.7248C18.603 13.8086 18.8446 13.7032 18.9284 13.489C19.3521 12.4078 19.5846 11.2307 19.5846 9.99984C19.5846 4.71067 15.2905 0.416504 10.0013 0.416504C4.71214 0.416504 0.417969 4.71067 0.417969 9.99984C0.417969 15.289 4.71214 19.5832 10.0013 19.5832C11.2355 19.5832 12.4151 19.3494 13.4988 18.9236C13.713 18.8398 13.8184 18.5978 13.7346 18.3836C13.6505 18.1694 13.4084 18.064 13.1942 18.1482Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="0.35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3213 14.895C11.6175 15.2296 10.8304 15.4167 10 15.4167C7.01042 15.4167 4.58333 12.9896 4.58333 10C4.58333 7.01042 7.01042 4.58333 10 4.58333C12.9896 4.58333 15.4167 7.01042 15.4167 10C15.4167 10.8304 15.2296 11.6175 14.895 12.3208C14.7962 12.5288 14.8846 12.7775 15.0921 12.8763C15.3 12.975 15.5487 12.8867 15.6475 12.6787C16.0337 11.8667 16.25 10.9583 16.25 10C16.25 6.55042 13.4496 3.75 10 3.75C6.55042 3.75 3.75 6.55042 3.75 10C3.75 13.4496 6.55042 16.25 10 16.25C10.9583 16.25 11.8667 16.0337 12.6787 15.6475C12.8867 15.5487 12.975 15.3 12.8763 15.0921C12.7775 14.8846 12.5288 14.7962 12.3213 14.895Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="0.35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1189 12.0797C10.0801 12.0818 10.0414 12.083 10.0026 12.083C8.8526 12.083 7.91927 11.1497 7.91927 9.99967C7.91927 8.84967 8.8526 7.91634 10.0026 7.91634C11.1526 7.91634 12.0859 8.84967 12.0859 9.99967C12.0859 10.0384 12.0847 10.0772 12.0826 10.1159C12.0701 10.3455 12.2464 10.5422 12.4759 10.5547C12.7055 10.5676 12.9022 10.3913 12.9147 10.1618C12.9176 10.108 12.9193 10.0538 12.9193 9.99967C12.9193 8.39009 11.6122 7.08301 10.0026 7.08301C8.39302 7.08301 7.08594 8.39009 7.08594 9.99967C7.08594 11.6093 8.39302 12.9163 10.0026 12.9163C10.0568 12.9163 10.1109 12.9147 10.1647 12.9118C10.3943 12.8993 10.5705 12.7026 10.558 12.473C10.5451 12.2434 10.3484 12.0672 10.1189 12.0797Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="0.35"
        />
      </g>
      <defs>
        <clipPath id="clip0_12655_3802">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChallengesIcon;
